<div class="modal__header">
	<div class="modal__header-actions header-actions--mobile">
			<button [attr.aria-label]="'bookingSearch.aria.closeDialog' | ibeadmin | async" (click)="backMobile()">
					<app-svg svg="icons.svg#general--arrow--left-no_margin" aria-hidden="true" [alt]="'Arrow left icon'"></app-svg>
				</button>
		</div>
	<div class="title_wrapper">
		<h2 class="title" id="modal__title">{{INDRA_printTitle()}}</h2>
		<span class="sub-title">{{INDRA_printSubTitle()}}</span>
	</div>
	<div class="modal__header-actions header-actions">
		<button [attr.aria-label]="'bookingSearch.aria.closeDialog' | ibeadmin | async" (click)="closeModal()">
			<app-svg svg="icons.svg#general--close" aria-hidden="true" [alt]="'Close icon'"></app-svg>
		</button>
	</div>
</div>
<div class="modal__body select-region-body sl--scrollable" [ngClass]="{ 'is-selecting-country': isSelectingCountry, 'is-selecting-airport': isSelectingAirport}" *ngIf="!isLoading">
	<ng-container *ngIf="!continentAPIError">	
		<ul class="regions-wrapper">
			<li class="item__region" *ngFor="let region of regions;let index = index" (click)="INDRA_handleSelectRegionClick(index)" [ngClass]="{ 'is-active': selectedRegion === index}">
					<span class="item__region-label">{{region.name}}</span>
					<app-world-map-svg class="item__region-img item__region-img--{{region.id}}"></app-world-map-svg>
					<app-svg class="item__mobile-arrow" svg="icons.svg#general--arrow--right" aria-hidden="true" [alt]="'Arrow right icon'"></app-svg>
			</li>

		</ul>
		<ul class="countries-wrapper">
			<li class="item__country" [ngClass]="{ 'is-open': country.code === selectedCountryCode }" *ngFor="let country of INDRAgetRegionCountries()" (click)="INDRA_handleSelectCountryClick(country.code)">
				<div class="item__country-wrapper">
					<span class="item__country-label">{{country.name}}</span>
					<app-svg class="item__mobile-arrow" svg="icons.svg#general--arrow--right" aria-hidden="true" [alt]="'Arrow right icon'"></app-svg>
				</div>
				<ul class="airports-wrapper--desktop" *ngIf="selectedCountryCode === country.code">
					<li class="item__airport" *ngFor="let airport of airports; let index = index" (click)="INDRA_handleSelectAirportClick(airport)">
							<span class="autocomplete__results__item-iata">
								{{airport.airportCode}}
							</span>
							<span class="autocomplete__results__item-label"><span class="bold">{{airport.airportName}}, </span>{{airport.cityName}}</span>
					</li>
				</ul>
			</li>
		</ul>

		<!-- mobile view -->
		<ul class="airports-wrapper">
				<li class="item__airport" *ngFor="let airport of getCountryAirports(); let index = index" (click)="INDRA_handleSelectAirportClick(airport)">
				<span class="autocomplete__results__item-iata">
					{{airport.airportCode}}
				</span>
				<span>
					<span class="bold">{{airport.airportName}}, </span>{{airport.cityName}}
				</span>
			</li>
		</ul>
	</ng-container>	
	<ng-container *ngIf="continentAPIError">
		<div  class="large-input__error">
			<span>{{INDRA_printErrorMessage()}}</span>
		</div>
	</ng-container>
</div>

<app-loading *ngIf="isLoading"></app-loading>
